import Phaser from 'phaser';
import { WANTED } from '../config';

export class WantedSystem extends Phaser.Events.EventEmitter {
  stars = 0; // float; rendered as floor
  private accumulator = 0;
  private lastSeenAt = 0;

  constructor() { super(); }

  bump(amount: number) {
    const before = Math.floor(this.stars);
    this.stars = Math.min(WANTED.max, this.stars + amount);
    const after = Math.floor(this.stars);
    if (after !== before) this.emit('change', after);
    this.lastSeenAt = performance.now();
  }

  /** Call when cops have line-of-sight on player to suspend decay. */
  noteSighting(now: number) { this.lastSeenAt = now; }

  update(now: number, dt: number) {
    if (this.stars <= 0) return;
    if (now - this.lastSeenAt > 4000) {
      const before = Math.floor(this.stars);
      this.stars = Math.max(0, this.stars - WANTED.decayPerSec * dt);
      const after = Math.floor(this.stars);
      if (after !== before) this.emit('change', after);
    }
  }

  get level(): number { return Math.floor(this.stars); }
}
